'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface SuccessMessageProps {
  isVisible: boolean;
  onClose: () => void;
  category: string;
  amount: number;
}

const SuccessMessage: React.FC<SuccessMessageProps> = ({
  isVisible,
  onClose,
  category,
  amount,
}) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-background/80 backdrop-blur-sm">
      <div className="bg-card rounded-lg shadow-sacred-lg max-w-md w-full p-8 text-center">
        <div className="w-16 h-16 bg-success/10 rounded-full flex items-center justify-center mx-auto mb-4">
          <Icon name="CheckCircleIcon" size={32} className="text-success" variant="solid" />
        </div>

        <h2 className="font-playfair text-2xl font-semibold text-foreground mb-2">
          Thank You for Your Blessing!
        </h2>

        <p className="font-inter text-sm text-muted-foreground mb-6 leading-relaxed">
          Your contribution of ${amount.toLocaleString('en-US')} to {category} has been received. May God bless your generosity abundantly.
        </p>

        <div className="bg-surface rounded-lg p-4 border border-border mb-6">
          <p className="font-inter text-xs text-foreground italic">
            "Each of you should give what you have decided in your heart to give, not reluctantly or under compulsion, for God loves a cheerful giver."
          </p>
          <p className="font-inter text-xs text-muted-foreground mt-2">
            2 Corinthians 9:7
          </p>
        </div>

        <button
          onClick={onClose}
          className="w-full px-6 py-3 rounded-md font-inter text-sm font-medium bg-primary text-primary-foreground hover:bg-primary/90 shadow-md hover:shadow-lg transition-all duration-200"
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default SuccessMessage;